import { jsonApi } from '@models/jsonApi';

jsonApi.define('dms/stream_alert', {
  id: null,
  email: '',
  notify_on_error: false,
  notify_on_success: false,
});
